import { gql } from '@apollo/client';

export const ANALYTICS_ENABLED_BY_STANDORTGRUPPEN_ID = gql(`
  query analyticsEnabledByStandortGruppenId($standortGruppenId: String!) {
   navigation_standortgruppeById(standortGruppenId: $standortGruppenId) {
      id
      istAnalyticsEnabled
    }
  }
`);
